import { ADMIN_TOKEN_KEY } from "@/lib/constants";

// Manche Browser blockieren localStorage in restriktiven Datenschutz- oder
// eingebetteten Ansichten. Eine Sitzung darf dadurch nicht als Loginfehler
// erscheinen. sessionStorage hält den Token mindestens für die geöffnete App.
export const getAdminToken = () => {
  try {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    if (token) return token;
  } catch (_) {
    // Fallback below.
  }
  try {
    return sessionStorage.getItem(ADMIN_TOKEN_KEY);
  } catch (_) {
    return null;
  }
};

export const saveAdminToken = (token) => {
  if (!token) throw new Error("Keine Anmeldesitzung erhalten");
  try {
    localStorage.setItem(ADMIN_TOKEN_KEY, token);
    return "local";
  } catch (_) {
    try {
      sessionStorage.setItem(ADMIN_TOKEN_KEY, token);
      return "session";
    } catch (_) {
      throw new Error("Der Browser blockiert die Sitzungsspeicherung");
    }
  }
};

export const clearAdminToken = () => {
  try { localStorage.removeItem(ADMIN_TOKEN_KEY); } catch (_) { /* ignored */ }
  try { sessionStorage.removeItem(ADMIN_TOKEN_KEY); } catch (_) { /* ignored */ }
};
